export default __webpack_public_path__ + "static/media/light-bg-header.8842add9.svg";